<template>
  <div class="auth-page-container bg-white py-4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <!-- Tab Content -->
          <div class="tab-content bg-white rounded">
            <div
              v-if="activeTab === 'login'"
              class="tab-pane fade show active"
            >
              <Login
                @login-success="handleAuthSuccess"
                @switch-to-register="switchTab('register')"
                @switch-to-forgot="switchTab('forgot')"
              />
            </div>
            <div
              v-if="activeTab === 'register'"
              class="tab-pane fade show active"
            >
              <Register
                @register-success="handleAuthSuccess"
                @switch-to-login="switchTab('login')"
              />
            </div>
            <div
              v-if="activeTab === 'forgot'"
              class="tab-pane fade show active"
            >
              <ForgotPassword
                :isModal="false"
                @forgot-success="handleForgotSuccess"
                @switch-to-login="switchTab('login')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Login from '@/components/Modules/Authentication/Login/index.vue';
import Register from '@/components/Modules/Authentication/Register/index.vue';
import ForgotPassword from '@/components/Modules/Authentication/ForgotPassword/index.vue';

export default defineComponent({
  name: 'AuthPage',
  components: {
    Login,
    Register,
    ForgotPassword
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const activeTab = ref<'login' | 'register' | 'forgot'>('login');

    // Watch for changes in the route parameter to update the active tab
    watch(() => route.params.tab, (newTab) => {
      if (newTab && ['login', 'register', 'forgot'].includes(newTab as string)) {
        activeTab.value = newTab as 'login' | 'register' | 'forgot';
      } else {
        activeTab.value = 'login'; // Default to login if no valid tab param
      }
    }, { immediate: true }); // Immediate to set initial tab

    const switchTab = (tab: 'login' | 'register' | 'forgot') => {
      activeTab.value = tab;
      router.replace({ params: { tab } }); // Update URL without adding to history
    };

    const handleAuthSuccess = () => {
      router.push('/dashboard'); // Redirect to dashboard on successful login/registration
    };

    const handleForgotSuccess = () => {
      // After successful password reset request, switch to login tab after 10 seconds
      setTimeout(() => {
        switchTab('login');
      }, 10000); // 10 seconds
    };

    onMounted(() => {
      // Redirect alla dashboard con query parameter per aprire la modale
      router.push({
        path: '/dashboard',
        query: { openAuth: activeTab.value }
      });
    });

    return {
      activeTab,
      switchTab,
      handleAuthSuccess,
      handleForgotSuccess
    };
  }
});
</script>

<style scoped>
.auth-page-container {
  padding: 1rem 0;
}

@media (min-width: 992px) {
  .tab-content {
    max-width: 1200px;
    margin: 0 auto;
  }
}

/* Modifica le proporzioni delle colonne principali del layout: immagine più piccola (4 colonne), form più grande (8 colonne) */
.tab-content :deep(.m-auto.m-1230 > .row > .col-lg-6:has(img)) {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.tab-content :deep(.m-auto.m-1230 > .row > .col-lg-6:not(:has(img))) {
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}

/* Limita l'altezza dell'immagine */
.tab-content :deep(img) {
  max-height: 500px;
  height: auto;
  width: 100%;
  object-fit: cover;
}
</style>
